import { render, staticRenderFns } from "./Biometria.vue?vue&type=template&id=7926fdaa&scoped=true"
import script from "./Biometria.vue?vue&type=script&lang=js"
export * from "./Biometria.vue?vue&type=script&lang=js"
import style0 from "./Biometria.vue?vue&type=style&index=0&id=7926fdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7926fdaa",
  null
  
)

export default component.exports